import React from 'react';
import { useHistory } from 'react-router-dom';
import constants from '../../../../../core/constants';
import Frame from '../../../../components/Frame';
import useProfile from '../../../../hooks/useProfile';
import {
  FixedWithContainer,
  MainContainer
} from '../../../common/CardBoardStyled';
import { ButtonBack } from '../../../procedures/modules/certificates-constancies/type1/info/components';

const EmbeddedViewController = ({
  ButtonBackEnabled = true,
  containerEnabled = true
}) => {
  const history = useHistory();
  const goBackButton = () => {
    history.goBack();
  };
  const { profile, academic } = useProfile();
  return (
    <MainContainer
      className={containerEnabled ? 'containerProcedureB containerService' : ''}
      data-testid="cmp-mean-view-embedded"
    >
      {ButtonBackEnabled && <ButtonBack onClick={goBackButton} />}

      <FixedWithContainer>
        <Frame
          source={`${constants.PE_URL}${constants.PE_PATH_RESERVE_RESOURCES}`}
          title="Portal del Estudiante"
        >
          <input type="hidden" name="Emplid" value={profile.peopleCode} />
          <input type="hidden" name="Grado" value={academic.career} />
          <input type="hidden" name="CodutpAlu" value={profile.studentCode} />
          <input type="hidden" name="Strm" value={academic.period.id} />
        </Frame>
      </FixedWithContainer>
    </MainContainer>
  );
};

export default EmbeddedViewController;
